export const getFeedbackRequestError = state => state.feedback.error;
export const getFeedbackRequestLoading = state => state.feedback.loading;
